import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Calculator, Sparkles, PartyPopper } from "lucide-react";
import { fetchAssessmentMeta } from "../lib/api";

export const DISCOUNT_CTA_DESC =
  "Answer 15 simple questions and discover the discount you can earn on your course. Get up to 30% off based on your score.";
export const LAUNCH_CTA_DESC =
  "As a part of our website launch, you are eligible for a 50% discount. Seats are filling up soon — available for the first 100 students only.";

let cachedMeta = null;
export const useDiscountMeta = () => {
  const [meta, setMeta] = useState(cachedMeta || { mode: "launch", education_levels: [], total_questions: 15 });
  useEffect(() => {
    if (cachedMeta) return;
    fetchAssessmentMeta().then((m) => { cachedMeta = m; setMeta(m); }).catch(() => {});
  }, []);
  return meta;
};

export const DiscountCTA = ({ testId = "discount-cta", size = "md", showDesc = true, descClass = "" }) => {
  const { mode } = useDiscountMeta();
  const launch = mode === "launch";
  const sizing = size === "lg" ? "h-16 px-10 text-lg" : "h-14 px-8 text-base";
  return (
    <div className="discount-cta-wrap">
      <Link to="/discount-assessment" data-testid={testId} className="inline-block">
        <span className={`discount-cta-btn ${sizing}`}>
          <span className="discount-cta-shine" aria-hidden="true" />
          {launch ? <PartyPopper className="w-5 h-5 relative" /> : <Calculator className="w-5 h-5 relative" />}
          <span className="relative">{launch ? "Claim 50% Launch Discount" : "Calculate Your Discount"}</span>
          <Sparkles className="w-4 h-4 relative text-[#FFF3B0]" />
        </span>
      </Link>
      {showDesc && (
        <p data-testid={`${testId}-desc`} className={`mt-3 text-sm leading-relaxed max-w-md ${descClass}`}>
          {launch ? LAUNCH_CTA_DESC : DISCOUNT_CTA_DESC}
        </p>
      )}
    </div>
  );
};

export default DiscountCTA;
